// src/pages/PageMenu/CompanyDefinitions.jsx
// تعريفات الشركة — بالتصميم الموحّد (MenuKit) مع دعم الترجمة

import React from "react";
import { useAuth } from "../../context/AuthContext";
import { PERMISSIONS } from "../../constants/permissions";
import { MenuPage } from "../../components/Menu/MenuKit";

import BusinessIcon from "@mui/icons-material/Business";
import ApartmentIcon from "@mui/icons-material/Apartment";
import PeopleIcon from "@mui/icons-material/People";
import SettingsSuggestOutlinedIcon from "@mui/icons-material/SettingsSuggestOutlined";
import TuneIcon from "@mui/icons-material/Tune";

export default function CompanyDefinitions() {
  const { hasPermission } = useAuth();
  const can = (key) => !!PERMISSIONS[key] && hasPermission(PERMISSIONS[key]);

  const sections = [
    {
      key: "definitions",
      titleKey: "companyDefinitions.sectionTitle", titleFallback: "التعريفات الأساسية",
      subtitleKey: "companyDefinitions.sectionDesc", subtitleFallback: "بيانات المنشأة والفروع والمستخدمين",
      icon: <TuneIcon />, color: "#4F46E5",
      items: [
        { key: "profile", nameKey: "companyDefinitions.companyProfile", nameFallback: "بيانات المنشأة", icon: <BusinessIcon />, color: "#4F46E5", link: "/company/profile" },
        { key: "branches", nameKey: "companyDefinitions.branchDefinition", nameFallback: "الفروع", icon: <ApartmentIcon />, color: "#0891B2", link: "/branches" },
        can("USER_MANAGE") && { key: "users", nameKey: "companyDefinitions.users", nameFallback: "المستخدمين", icon: <PeopleIcon />, color: "#2563EB", link: "/UserForm" },
      ],
    },
  ];

  return (
    <MenuPage
      titleKey="companyDefinitions.title" titleFallback="تعريفات الشركة"
      subtitleKey="companyDefinitions.subtitle" subtitleFallback="بيانات المنشأة والفروع والمستخدمين"
      icon={<SettingsSuggestOutlinedIcon />}
      sections={sections}
    />
  );
}